var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.classes },
    [
      _c("h4", [
        _vm._v(_vm._s(_vm._f("fullDateTime")(_vm.potentialDate.timeStamp)))
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "communication-appointment-fan--appointment-confirmation"
        },
        [
          _vm._v(
            "\n\t\t" +
              _vm._s(
                _vm.potentialDate.confirmed
                  ? "Bestätigt"
                  : "Noch nicht bestätigt"
              ) +
              "\n\t"
          )
        ]
      ),
      _vm._v(" "),
      _vm.isListTypeApplicant
        ? _c("h2", [_vm._v(_vm._s(_vm.potentialDate.jobProfile.info))])
        : _c("h2", [
            _vm._v(_vm._s(_vm.potentialDate.disclosedData.nameWithSalutation))
          ]),
      _vm._v(" "),
      _c("AppointmentInfos", {
        attrs: {
          appointment: _vm.potentialDate.appointment,
          type: _vm.appointmentInfosType
        },
        on: {
          sentAccessLink: function($event) {
            return _vm.$emit("sentAccessLink")
          }
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "communication-appointment-fan--appointment-actions" },
        [
          _c(
            "div",
            [
              !_vm.potentialDate.pastDue
                ? _c("Button", {
                    attrs: { text: "Termin verschieben", smaller: "" },
                    on: { click: _vm.moveAppointment }
                  })
                : _vm._e()
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }